import { useTranslation } from "react-i18next";
import { BookOpen } from "lucide-react";
import { clsx } from "clsx";
import { helpUrl } from "./help";

/** A small link to the handbook page about what is on screen (ADR 0021), in the UI's language, in a new tab. */
export function HelpLink({ page, className }: { page: string; className?: string }) {
  const { t, i18n } = useTranslation();
  return (
    <a
      href={helpUrl(page, i18n.language)}
      target="_blank"
      rel="noopener"
      aria-label={t("help.page")}
      title={t("help.page")}
      data-testid="help-link"
      className={clsx(
        "inline-grid h-7 w-7 shrink-0 place-items-center rounded-sm text-neutral-400 hover:bg-neutral-100 hover:text-accent touch:h-11 touch:w-11 dark:hover:bg-neutral-800",
        className,
      )}
    >
      <BookOpen size={15} aria-hidden />
    </a>
  );
}
